let enabled = true;
let url = '';
let environment = '';

export function isPlaidInstalled() {
  return !!window.Plaid;
}

export function isPlaidEnabled() {
  return enabled;
}

export function loadJS(callback = () => {}) {
  if (isPlaidInstalled() || !isPlaidEnabled()) {
    return;
  }
  const ref = window.document.getElementsByTagName('head')[0];
  const script = window.document.createElement('script');

  script.src = url;
  script.async = true;
  if (script.readyState) {
    script.onreadystatechange = function _() {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = function _() {
      callback();
    };
  }
  ref.appendChild(script);
}

export function renderPlaid(callback, linkToken) {
  // https://plaid.com/docs/link/web/#create
  const plaid = window.Plaid?.create({
    clientName: 'ZenBusiness',
    env: environment,
    token: linkToken,
    product: ['auth'],
    onSuccess: (publicToken, metadata) => {
      callback({ publicToken, metadata, error: null });
    },
    onExit: (error, metadata) => {
      callback({ error, metadata });
    }
  });
  return plaid;
}

export function initPlaid(PLAID, isProd) {
  const byZenBusinessEnvironment = isProd ? 'production' : 'sandbox';
  // TODO: needs to be restored to commented when vars will be available on dev
  // enabled = PLAID.ENABLED;
  // url = PLAID.URL;
  // environment = PLAID.ENV;
  enabled = PLAID?.ENABLED === undefined ? true : PLAID.ENABLED;
  url =
    PLAID?.URL === undefined
      ? 'https://cdn.plaid.com/link/v2/stable/link-initialize.js'
      : PLAID.URL;
  environment = byZenBusinessEnvironment;
  if (PLAID) {
    loadJS();
  }
}

export function getPlaid({ plaidLinkCallback, linkToken } = {}) {
  if (!isPlaidEnabled()) {
    plaidLinkCallback({ publicToken: '', metadata: {} });
    return null;
  }
  if (isPlaidInstalled()) {
    return renderPlaid(plaidLinkCallback, linkToken);
  }

  throw new Error('Plaid not installed');
}
